import React from 'react';
import { computePleAggregateTotal, resolvePleDivision } from './aggregateUtils';

export default function StudentBio({ report, templateOne = false, showAttendance = true, showPromotion = true, showClassPosition = false, showStreamPosition = false, showDivision = false, showAggregate = false, showTotalAggregate = true, showStream = true }) {
  const s = report?.student;
  const fullName = s?.full_name || `${s?.last_name || ''} ${s?.first_name || ''} ${s?.middle_name || ''}`.trim();
  const classDisplay = report?.class?.name || s?.school_class?.name || s?.classStream?.schoolClass?.name || '-';
  const streamDisplay = report?.stream?.name || s?.stream?.name || s?.classStream?.stream?.name || '-';
  const photoUrl = s?.profile_picture_url || s?.photo_url || s?.avatar_url || null;
  const aggregateTotal = report?.aggregate_total
    ?? computePleAggregateTotal(report?.subjects_data, report?.subjects_counted ?? 4);
  const division = showDivision ? (report?.division || resolvePleDivision(aggregateTotal)) : null;
  const showAggregateDisplay = showTotalAggregate && aggregateTotal != null;

  if (templateOne) {
    return (
      <table className="rc-table rc-bio-table" style={{ marginBottom: 8 }}>
        <tbody>
          <tr>
            <th className="rc-bio-label" style={{ width: '15%' }}>Name</th>
            <td className="rc-bio-value" style={{ width: '35%' }}>{fullName || '-'}</td>
            <th className="rc-bio-label" style={{ width: '15%' }}>Reg. No</th>
            <td className="rc-bio-value" style={{ width: '35%' }}>{s?.registration_no || '-'}</td>
          </tr>
          <tr>
            <th className="rc-bio-label">Class</th>
            <td className="rc-bio-value">{classDisplay}</td>
            <th className="rc-bio-label">Gender</th>
            <td className="rc-bio-value">{s?.gender || '-'}</td>
          </tr>
        </tbody>
      </table>
    );
  }

  return (
    <div className="rc-bio" style={{ gap: photoUrl ? '12px' : '0' }}>
      {photoUrl && <img src={photoUrl} alt="student" className="rc-bio-photo" />}
      <div className="rc-bio-grid">
        <div>
          <div className="rc-bio-row"><span className="rc-bio-label">Name:</span><span className="rc-bio-value">{fullName || '-'}</span></div>
          <div className="rc-bio-row"><span className="rc-bio-label">Class:</span><span className="rc-bio-value">{classDisplay}</span></div>
          {showStream && streamDisplay !== '-' && (
            <div className="rc-bio-row"><span className="rc-bio-label">Stream:</span><span className="rc-bio-value">{streamDisplay}</span></div>
          )}
          {showClassPosition && report?.class_position != null && (
            <div className="rc-bio-row"><span className="rc-bio-label">Class Position:</span><span className="rc-bio-value">{report.class_position} / {report.class_total_students ?? '-'}</span></div>
          )}
          {showAggregateDisplay && aggregateTotal != null && (
            <div className="rc-bio-row"><span className="rc-bio-label">Aggregate:</span><span className="rc-bio-value">{aggregateTotal}</span></div>
          )}
        </div>
        <div>
          <div className="rc-bio-row"><span className="rc-bio-label">Reg. No:</span><span className="rc-bio-value">{s?.registration_no || '-'}</span></div>
          <div className="rc-bio-row"><span className="rc-bio-label">Gender:</span><span className="rc-bio-value">{s?.gender || '-'}</span></div>
          {showStreamPosition && report?.stream_position != null && (
            <div className="rc-bio-row"><span className="rc-bio-label">Stream Position:</span><span className="rc-bio-value">{report.stream_position} / {report.stream_total_students ?? '-'}</span></div>
          )}
          {showDivision && division != null && (
            <div className="rc-bio-row"><span className="rc-bio-label">Division:</span><span className="rc-bio-value">{division}</span></div>
          )}

        </div>
      </div>
    </div>
  );
}
